import { AnonymLayout } from 'app/layouts/AnonymLayout';
import { NavigateToAWebsite } from 'app/helpers/navigateToAWebsite';
import { LoginPage } from 'app/pages/LoginPage';
import { ResetPasswordPage } from 'app/pages/ResetPasswordPage';
import { SignupPage } from 'app/pages/SignupPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Routes as AppRoutes } from 'src/types/routes';

export const AnonymousRouter = () => {
    return (
        <Routes>
            <Route element={<AnonymLayout />}>
                <Route path={AppRoutes.Dashboard.Login} element={ <LoginPage /> } />
                <Route path={AppRoutes.Dashboard.Signup} element={ <SignupPage /> } />
                <Route path={AppRoutes.Dashboard.ResetPassword} element={ <ResetPasswordPage /> } />

                <Route path={`${AppRoutes.Dashboard.Home}/*`} element={<Navigate to={AppRoutes.Dashboard.Login}/>} />
            </Route>

            <Route path="*" element={<NavigateToAWebsite location={AppRoutes.Home}/>} />
        </Routes>
    );
};
